import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import DeleteFinancialPeriodContent from "./DeleteFinancialPeriodContent";

export const DeleteFinancialPeriodDialog = () => {
  return (
    <HubDialogWrapper maxWidth="sm" name="delete-financial-period">
      <DeleteFinancialPeriodContent />
    </HubDialogWrapper>
  );
};

export default DeleteFinancialPeriodDialog;
